var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.252,
    cx: 26.5,
    cy: 26.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19h9a4 4 0 014 4v7.8a4 4 0 01-4 4h-9a4 4 0 01-4-4V23a4 4 0 014-4zm15.452 4.968l3.36-2.198a1 1 0 011.548.836v8.28a1 1 0 01-1.489.873l-3.36-1.88a1 1 0 01-.511-.873v-4.201a1 1 0 01.452-.837z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/VideoIcon.c5b32f75e9306ae264a324f364eb4e23.svg";
export { ForwardRef as ReactComponent };